import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Layout as AntLayout, Menu, Dropdown, Avatar, Space, Button } from 'antd';
import {
  DashboardOutlined,
  UserOutlined,
  TagsOutlined,
  PictureOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UploadOutlined,
  UnorderedListOutlined,
  FileImageOutlined,
} from '@ant-design/icons';

const { Header, Sider, Content } = AntLayout;

const menuItems = [
  {
    key: '/',
    icon: <DashboardOutlined />,
    label: '仪表盘',
  },
  {
    key: '/users',
    icon: <UserOutlined />,
    label: '用户管理',
  },
  {
    key: '/categories',
    icon: <TagsOutlined />,
    label: '分类管理',
  },
  {
    key: 'stickers',
    icon: <PictureOutlined />,
    label: '贴纸管理',
    children: [
      {
        key: '/stickers/upload',
        icon: <UploadOutlined />,
        label: '贴纸上传',
      },
      {
        key: '/stickers',
        icon: <UnorderedListOutlined />,
        label: '贴纸列表',
      },
    ],
  },
  {
    key: '/templates',
    icon: <FileImageOutlined />,
    label: '模板管理',
  },
];

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [adminInfo, setAdminInfo] = useState(null);
  const [openKeys, setOpenKeys] = useState(['stickers']);

  useEffect(() => {
    const info = localStorage.getItem('admin_info');
    if (info) {
      setAdminInfo(JSON.parse(info));
    }
  }, []);

  // 根据当前路径设置展开的菜单
  useEffect(() => {
    if (location.pathname.startsWith('/stickers')) {
      setOpenKeys(['stickers']);
    }
  }, [location.pathname]);

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_info');
    navigate('/login');
  };

  const userMenuItems = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout,
    },
  ];

  const handleMenuClick = ({ key }) => {
    navigate(key);
  };

  const handleOpenChange = (keys) => {
    setOpenKeys(keys);
  };

  // 获取当前选中的菜单项
  const getSelectedKeys = () => {
    const path = location.pathname;
    // 精确匹配贴纸上传路径
    if (path === '/stickers/upload') {
      return ['/stickers/upload'];
    }
    // 贴纸列表和编辑页面
    if (path === '/stickers' || path.match(/^\/stickers\/\d+\/edit$/)) {
      return ['/stickers'];
    }
    // 创建贴纸页面也归入贴纸列表
    if (path === '/stickers/create') {
      return ['/stickers'];
    }
    return [path];
  };

  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={240}
        style={{
          overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
        }}
      >
        <div
          style={{
            height: 64,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderBottom: '1px solid rgba(255,255,255,0.1)',
          }}
        >
          <span
            style={{
              fontSize: collapsed ? 20 : 18,
              fontWeight: 700,
              color: '#fff',
              whiteSpace: 'nowrap',
            }}
          >
            {collapsed ? '🎨' : '🎨 贴纸管理系统'}
          </span>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={getSelectedKeys()}
          openKeys={collapsed ? [] : openKeys}
          onOpenChange={handleOpenChange}
          items={menuItems}
          onClick={handleMenuClick}
          style={{ marginTop: 16 }}
        />
      </Sider>
      <AntLayout style={{ marginLeft: collapsed ? 80 : 240, transition: 'all 0.2s' }}>
        <Header className="layout-header">
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{ fontSize: 16 }}
          />
          <Space>
            <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
              <Space style={{ cursor: 'pointer' }}>
                <Avatar
                  style={{ backgroundColor: '#667eea' }}
                  icon={<UserOutlined />}
                />
                <span>{adminInfo?.username || '管理员'}</span>
              </Space>
            </Dropdown>
          </Space>
        </Header>
        <Content style={{ background: '#f0f2f5' }}>
          <Outlet />
        </Content>
      </AntLayout>
    </AntLayout>
  );
};

export default Layout;
